// extracted by mini-css-extract-plugin
module.exports = {"content":"HVYfL","footer":"K-uQ8"};